// Servizio API per mini-server

//TPT: /api
// MODIFICA DA COSÌ:
// const API_BASE_URL = 'http://localhost:3006/api';

// A COSÌ (Valido sia in locale con il proxy di Vite, sia online su gledger.net):
const API_BASE_URL = '/api';

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
    this.token = localStorage.getItem('gledger_token');
    this.user = JSON.parse(localStorage.getItem('gledger_user') || 'null');
  }

  getHeaders() {
    return {
      'Content-Type': 'application/json',
    };
  }

  async login(username, password) {
    try {

      //\\bef const response = await fetch(`${this.baseURL}/api/login`, {
      const response = await fetch(`${this.baseURL}/login`, {

        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify({ username, password })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Login failed');
      }

      const data = await response.json();
      this.token = data.token;
      this.user = data.user;
      
      localStorage.setItem('gledger_token', this.token);
      localStorage.setItem('gledger_user', JSON.stringify(this.user));
      
      return data;
    } catch (err) {
      console.error('Login error:', err);
      throw err;
    }
  }

  async getConti() {

    debugger;

    try {
      if (!this.user) throw new Error('User not authenticated');
      
    debugger;

      //\\ const response = await fetch(`${this.baseURL}/api/conti?user_id=${this.user.id}`, {
      const response = await fetch(`${this.baseURL}/conti?user_id=${this.user.id}`, {
        headers: this.getHeaders()
      });

      if (!response.ok) {
        throw new Error('Failed to fetch conti');
      }

      return await response.json();
    } catch (err) {
      console.error('Get conti error:', err);
      throw err;
    }
  }

  async createConto(contoData) {
    try {
      if (!this.user) throw new Error('User not authenticated');
      
      const response = await fetch(`${this.baseURL}/api/conti`, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify({ ...contoData, user_id: this.user.id })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to create conto');
      }

      return await response.json();
    } catch (err) {
      console.error('Create conto error:', err);
      throw err;
    }
  }

  async updateConto(id, contoData) {
    try {
      if (!this.user) throw new Error('User not authenticated');
      
      const response = await fetch(`${this.baseURL}/api/conti/${id}`, {
        method: 'PUT',
        headers: this.getHeaders(),
        body: JSON.stringify({ ...contoData, user_id: this.user.id })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to update conto');
      }

      return await response.json();
    } catch (err) {
      console.error('Update conto error:', err);
      throw err;
    }
  }

  async deleteConti(id) {
    try {
      if (!this.user) throw new Error('User not authenticated');
      
      const response = await fetch(`${this.baseURL}/api/conti/${id}?user_id=${this.user.id}`, {
        method: 'DELETE',
        headers: this.getHeaders()
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to delete conto');
      }

      return await response.json();
    } catch (err) {
      console.error('Delete conto error:', err);
      throw err;
    }
  }

  async moveConto(contoId, newParentId) {
    try {
      if (!this.user) throw new Error('User not authenticated');
      
      // Recupera i dati del conto dalla lista esistente nel frontend
      const contiResponse = await fetch(`${this.baseURL}/api/conti?user_id=${this.user.id}`, {
        headers: this.getHeaders()
      });
      
      if (!contiResponse.ok) {
        throw new Error('Failed to get conti list');
      }
      
      const allConti = await contiResponse.json();
      const contoData = allConti.find(c => c.id === parseInt(contoId));
      
      if (!contoData) {
        throw new Error('Conto not found in list');
      }
      
      // Aggiorna solo il parent, mantieni tutti gli altri campi
      const response = await fetch(`${this.baseURL}/api/conti/${contoId}`, {
        method: 'PUT',
        headers: this.getHeaders(),
        body: JSON.stringify({ 
          ...contoData,
          parent: newParentId, 
          user_id: this.user.id 
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to move conto');
      }

      return await response.json();
    } catch (err) {
      console.error('Move conto error:', err);
      throw err;
    }
  }

  async renumberPositions(parentId) {
    try {
      if (!this.user) throw new Error('User not authenticated');
      
      const response = await fetch(`${this.baseURL}/api/conti/renumber/${parentId || 'null'}`, {
        method: 'PUT',
        headers: this.getHeaders(),
        body: JSON.stringify({ user_id: this.user.id })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to renumber positions');
      }

      return await response.json();
    } catch (err) {
      console.error('Renumber positions error:', err);
      throw err;
    }
  }

  async duplicateConto(id, newName) {
    try {
      if (!this.user) throw new Error('User not authenticated');
      
      const response = await fetch(`${this.baseURL}/api/conti`, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify({ 
          name: newName,
          user_id: this.user.id 
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to duplicate conto');
      }

      return await response.json();
    } catch (err) {
      console.error('Duplicate conto error:', err);
      throw err;
    }
  }

  async logout() {
    this.token = null;
    this.user = null;
    localStorage.removeItem('gledger_token');
    localStorage.removeItem('gledger_user');
  }
}

export default new ApiService();
